// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DhKp","title":"styles_title__2bqMM"};